var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16.6 16.6",
    style: {
      enableBackground: "new 0 0 16.6 16.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#12D67D;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 8.3,
    cy: 8.3,
    r: 8.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.6,11.4C6.5,11.4,6.5,11.4,6.6,11.4c-0.2,0-0.5-0.1-0.6-0.3C5.2,9.9,3.9,8.8,3.9,8.8 c-0.3-0.2-0.3-0.7-0.1-1c0.2-0.3,0.7-0.3,1-0.1c0,0,1,0.8,1.8,1.9C7.4,8.7,9.2,7,11.9,5.2c0.3-0.2,0.7-0.1,0.9,0.2 c0.2,0.3,0.1,0.7-0.2,0.9c-3.7,2.4-5.5,4.8-5.5,4.8C7,11.3,6.8,11.4,6.6,11.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/icon-success.3b77da08ebb4a9e636e407f167a123de.svg";
export { ForwardRef as ReactComponent };